module.exports = __webpack_public_path__ + "img/manage_password_logo.ac5aafd9.svg";